import PrismaSubscriber from "models/data/prisma/PrismaSubscriber";

class PrismaToApiSubscriber {
	static map = prismaSubscriber => ({
		id: PrismaSubscriber.id(prismaSubscriber),
		email: PrismaSubscriber.email(prismaSubscriber),
		referralLink: PrismaSubscriber.referralLink(prismaSubscriber),
		numReferred: PrismaSubscriber.numReferred(prismaSubscriber),
		referrer: PrismaSubscriber.referrer(prismaSubscriber),
		sharedStoryLinkQuota: PrismaSubscriber.sharedStoryLinkQuota(prismaSubscriber)
	});
}

export default PrismaToApiSubscriber;
